// extracted by mini-css-extract-plugin
export default {"-large":"HuQpYTtt3Aa8F6wixdQM","timeRowText":"ACsoTo_enuIguISsUYJY","mobilePanel":"khmxCTNl7FdWBycBVnam","desktopArrow":"mkSgYp6aR0MoGNdvZNrw"};